import { deleteRequest, getRequest, postRequest, putRequest } from "../../../apiClient";
import { VendorsEndpoint } from "../../../apiEndpoints";

//#region----------------- GET-----------------------
export const GetVendors = async (queryString: any) => {
    var _url = VendorsEndpoint.VENDORS_URL + (queryString ?? "");
    var res = await getRequest(_url);

    return res;
};

export const GetVendorById = async (id: string | number) => {
    var _url = VendorsEndpoint.VENDORS_BY_ID_URL(id);
    var res = await getRequest(_url);

    return res;
};
//#endregion

//#region----------------- POST-----------------------
export const CreateVendorService = async (param: any) => {
    var res = await postRequest(VendorsEndpoint.VENDORS_URL, param);

    return res;
};
//#endregion

//#region----------------- PUT-----------------------
export const EditVendorService = async (id: string | number, param: any) => {
    var res = await putRequest(VendorsEndpoint.VENDORS_BY_ID_URL(id), param);

    return res;
};
//#endregion

//#region----------------- DELETE-----------------------
export const DeleteVendorService = async (id: string | number, param: any) => {
    var _url = VendorsEndpoint.VENDORS_DELETE_BY_ID_URL(id);
    var res = await postRequest(_url, param);

    return res;
};

//#endregion